/*
 * Tiefenwerk — Bühne als Karussell
 *
 * Blendet die Motive der Bühne nacheinander über. Das erste Motiv steht schon
 * im HTML; ohne Skript bleibt es einfach stehen. Der Wechsel hält an, solange
 * Maus oder Tastatur auf der Bühne sind, im Hintergrund-Tab und bei „Bewegung
 * reduzieren“ (dann gar kein automatischer Wechsel). Am Handy wechselt ein
 * Wischen das Motiv. Im Theme-Editor springt die Bühne zum gewählten Block und
 * bleibt dort stehen. Punkte und Pause-Knopf gibt es nicht mehr (Marcel,
 * 24.09.2026).
 */
(function () {
  'use strict';

  var MIN_INTERVALL_MS = 3000;
  var WISCHWEG_PX = 40;

  function Karussell(wurzel) {
    this.wurzel = wurzel;
    this.buehne = wurzel.closest('.hero-full') || wurzel;
    this.motive = [].slice.call(wurzel.querySelectorAll('.hero-full__motiv'));
    this.intervall = Math.max(Number(wurzel.getAttribute('data-intervall')) || 6000, MIN_INTERVALL_MS);
    var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.automatisch = wurzel.hasAttribute('data-automatisch') && !ruhig;
    this.index = 0;
    this.zeiger = null;
    this.gruende = {}; // warum gerade angehalten wird: zeiger, fokus, editor, versteckt
    this.aus = false;
    this.binde();
    this.plane();
  }

  /**
   * Das Bild eines Motivs. Die weiteren Motive laden mit loading="lazy", damit
   * die erste Ansicht schnell steht. Ein Karussell zeigt sie aber gleich danach;
   * am Handy blendete es deshalb auf ein Motiv, das noch gar nicht geladen war,
   * und die Bühne stand leer.
   */
  Karussell.prototype.bild = function (i) {
    var n = this.motive.length;
    var m = this.motive[((i % n) + n) % n];
    return m ? m.querySelector('img') : null;
  };

  /** Lädt ein Motiv sofort statt erst bei Sicht. */
  Karussell.prototype.vorladen = function (i) {
    var img = this.bild(i);
    if (img && img.getAttribute('loading') === 'lazy') img.setAttribute('loading', 'eager');
    return img;
  };

  Karussell.prototype.zeige = function (i) {
    var self = this;
    var img = this.vorladen(i);
    // Erst wechseln, wenn das Bild da ist. Nach spätestens zwei Sekunden
    // trotzdem, damit ein hängendes Bild das Karussell nicht anhält.
    if (img && !img.complete) {
      var fertig = false;
      var weiter = function () {
        if (fertig) return;
        fertig = true;
        self.wechsle(i);
      };
      img.addEventListener('load', weiter, { once: true });
      img.addEventListener('error', weiter, { once: true });
      setTimeout(weiter, 2000);
      return;
    }
    this.wechsle(i);
  };

  Karussell.prototype.wechsle = function (i) {
    var n = this.motive.length;
    var self = this;
    this.index = ((i % n) + n) % n;
    this.motive.forEach(function (m, j) {
      var an = j === self.index;
      m.classList.toggle('is-aktiv', an);
      if (an) m.removeAttribute('aria-hidden');
      else m.setAttribute('aria-hidden', 'true');
    });
    this.plane();
  };

  Karussell.prototype.angehalten = function () {
    for (var grund in this.gruende) if (this.gruende[grund]) return true;
    return false;
  };

  Karussell.prototype.plane = function () {
    var self = this;
    clearTimeout(this.zeiger);
    // Das nächste Motiv lädt, während das aktuelle steht
    this.vorladen(this.index + 1);
    if (this.aus || !this.automatisch || this.angehalten()) return;
    this.zeiger = setTimeout(function () { self.zeige(self.index + 1); }, this.intervall);
  };

  Karussell.prototype.halte = function (grund, an) {
    this.gruende[grund] = an;
    this.plane();
  };

  Karussell.prototype.stoppe = function () {
    this.aus = true;
    clearTimeout(this.zeiger);
  };

  Karussell.prototype.binde = function () {
    var self = this;
    var buehne = this.buehne;

    buehne.addEventListener('mouseenter', function () { self.halte('zeiger', true); });
    buehne.addEventListener('mouseleave', function () { self.halte('zeiger', false); });
    buehne.addEventListener('focusin', function () { self.halte('fokus', true); });
    buehne.addEventListener('focusout', function (e) {
      if (!buehne.contains(e.relatedTarget)) self.halte('fokus', false);
    });
    document.addEventListener('visibilitychange', function () { self.halte('versteckt', document.hidden); });

    // Wischen auf dem Motiv, nur waagerecht: Senkrecht scrollt die Seite.
    var start = null;
    this.wurzel.addEventListener('touchstart', function (e) {
      var t = e.touches[0];
      start = { x: t.clientX, y: t.clientY };
    }, { passive: true });
    this.wurzel.addEventListener('touchend', function (e) {
      if (!start) return;
      var t = e.changedTouches[0];
      var dx = t.clientX - start.x;
      var dy = t.clientY - start.y;
      start = null;
      if (Math.abs(dx) < WISCHWEG_PX || Math.abs(dx) < Math.abs(dy)) return;
      self.zeige(self.index + (dx < 0 ? 1 : -1));
    }, { passive: true });

    this.motive.forEach(function (m, j) {
      m.addEventListener('shopify:block:select', function () {
        self.halte('editor', true);
        self.zeige(j);
      });
      m.addEventListener('shopify:block:deselect', function () { self.halte('editor', false); });
    });
  };

  function starte(bereich) {
    (bereich || document).querySelectorAll('[data-tw-karussell]').forEach(function (w) {
      if (!w.twKarussell) w.twKarussell = new Karussell(w);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { starte(); });
  } else {
    starte();
  }

  document.addEventListener('shopify:section:load', function (e) { starte(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-tw-karussell]').forEach(function (w) {
      if (w.twKarussell) w.twKarussell.stoppe();
    });
  });
})();
